import { render, staticRenderFns } from "./area-rules-summary-dialog.component.vue?vue&type=template&id=9076d06c"
import script from "./area-rules-summary-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./area-rules-summary-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports